import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * Mobile-only sticky CTA at the bottom.
 * Shows the event date + primary CTA. Auto-hides when the registration form is on-screen.
 */
export default function MobileStickyCTA() {
  const [visible, setVisible] = useState(false);
  const [nearForm, setNearForm] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show after user scrolls a bit
      setVisible(window.scrollY > 340);

      // Hide when the form (#reservar) is close to viewport
      const target = document.getElementById("reservar");
      if (target) {
        const rect = target.getBoundingClientRect();
        const inView = rect.top < window.innerHeight * 0.7 && rect.bottom > 0;
        setNearForm(inView);
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const shouldShow = visible && !nearForm;

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 pointer-events-none"
          data-testid="mobile-sticky-cta"
        >
          <div className="mx-3 mb-3 pointer-events-auto rounded-lg bg-[#0B0E13] shadow-[0_-8px_24px_rgba(11,14,19,0.25)] border border-[#C7AA78]/40 overflow-hidden">
            <a
              href="#reservar"
              className="flex items-center justify-between gap-3 px-4 py-3"
              data-testid="mobile-sticky-cta-btn"
            >
              <div className="flex flex-col leading-tight">
                <span className="text-[9px] tracking-[0.22em] uppercase text-[#C7AA78] font-medium">
                  Próxima fecha muy pronto
                </span>
                <span className="text-[13px] text-[#F2EFEA] font-light">
                  Masterclass gratuita en directo
                </span>
              </div>
              <span className="text-[11px] tracking-[0.16em] uppercase font-medium text-[#0B0E13] bg-[#C7AA78] px-4 py-2.5 rounded-md whitespace-nowrap">
                Avísame →
              </span>
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
